/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEyebrowCuteFi: {
  name: 'eyebrow-cute-fi';
  data: string;
} = {
  name: 'eyebrow-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.84 8.027c-2.578.11-5.061.69-6.847 1.598-1.78.905-2.703 1.925-2.932 3.237-.149.852.004 1.597.485 2.369.956 1.536 2.983 2.161 4.834 1.49.11-.04.677-.262 1.26-.493 3.124-1.24 5.623-1.914 8.18-2.206a18.01 18.01 0 0 1 2.11-.105c1.347-.001 2.238.084 3.446.328.635.128.802.127 1.064-.006.35-.177.535-.482.538-.884.002-.237-.016-.3-.173-.6-.963-1.844-2.94-3.256-5.667-4.048-1.832-.532-4.087-.775-6.298-.68"/></svg>`
};
